import _findIndex from 'lodash/findIndex';
import _isEmpty from 'lodash/isEmpty';
import _omit from 'lodash/omit';
import * as ActionTypes from '../actions/types/RegistryCollectionActionTypes';

const initialState = {
  // byId: {},
  // orderedIds: [],
  busy: false,
  initialized: false,
  defaultCollectionObjectId: undefined,
  defaultCollection: [],
  otherCollections: [],
  facets: [],
  selectedFacetValues: {},
  sort: '',
  isFlattenedView: false,
  selectedCollectionObject: null,
  collectionList: [],
  collectionItem: null,
  isPDPDefaultGiftCard: false,
};

const registryCollectionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_SEARCH: {
      return Object.assign({}, state, { busy: true });
    }
    case ActionTypes.RECEIVE_SEARCH: {
      // The endpoint is annoying so this is necessary
      const collectionList = state.initialized
        ? state.collectionList
        : action.payload.collection_list;

      return Object.assign({}, state, {
        busy: false,
        initialized: true,
        facets: action.payload.facets,
        defaultCollectionObjectId: action.payload.default_collection_object_id,
        defaultCollection: action.payload.default_collection,
        otherCollections: action.payload.other_collections,
        collectionList,
        isFlattenedView: state.sort !== '' && state.selectedCollectionObject === '',
      });
    }
    case ActionTypes.TOGGLE_FACET_VALUE: {
      const facetValues = state.selectedFacetValues[action.payload.facetKey]
        ? [...state.selectedFacetValues[action.payload.facetKey]]
        : [];
      const index = _findIndex(facetValues, i => i === action.payload.valueKey);
      if (index > -1 || action.payload.valueKey === '') {
        facetValues.splice(index, 1);
      } else {
        facetValues.push(action.payload.valueKey);
      }

      const selectedFacetValues = { ...state.selectedFacetValues };
      if (_isEmpty(facetValues)) {
        delete selectedFacetValues[action.payload.facetKey];
      } else {
        selectedFacetValues[action.payload.facetKey] = facetValues;
      }

      return Object.assign({}, state, { selectedFacetValues });
    }
    case ActionTypes.RESET_FACET_VALUES: {
      if (action.payload.facetKey) {
        const selectedFacets = Object.assign({}, state.selectedFacetValues);

        return Object.assign({}, state, {
          selectedFacetValues: _omit(selectedFacets, action.payload.facetKey),
        });
      }

      return Object.assign({}, state, { selectedFacetValues: {} });
    }
    case ActionTypes.UPDATE_SORT: {
      return Object.assign({}, state, { sort: action.payload.sort });
    }
    case ActionTypes.SELECT_COLLECTION: {
      return Object.assign({}, state, {
        selectedCollectionObject: action.payload.collectionObject,
      });
    }
    case ActionTypes.REQUEST_DEFAULT_GIFT_CARD:
    case ActionTypes.REQUEST_REGISTRY_ITEM_BY_COLLECTION_ITEM_ID: {
      return Object.assign({}, state);
    }
    case ActionTypes.RECEIVE_DEFAULT_GIFT_CARD: {
      return Object.assign({}, state, {
        defaultGiftCard: action.payload,
        isPDPDefaultGiftCard: true,
      });
    }
    case ActionTypes.RECEIVED_REGISTRY_ITEM_BY_COLLECTION_ITEM_ID: {
      return Object.assign({}, state, { collectionItem: action.payload });
    }
    case ActionTypes.RESET: {
      return initialState;
    }
    default:
      return state;
  }
};

export default registryCollectionsReducer;
